import {
  AttributeCollection,
  getNodeComponentAttributeValue,
  setNodeComponentAttributeValue,
  setNodeStyleAttributeValue,
} from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { SiteData } from "../Data/SiteData";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import GetAttributeDefinition, { AttributeTargetType } from "../Data/WBData";
import RenderAttributeInput from "../StyleInputs/RenderAttributeInput";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import Accordian from "../Accordian";
import { GetLinkAndType, LinkTypes } from "vagaro-website-rendering/src/components/Definitions/LinkData";
import {  GetPhoneNumberLenthNoFormatting } from "../Utilities/PhoneUtils";

export default function PopupMenu({
  saveFunc,
  siteData,
}: {
  saveFunc: Function;
  siteData: SiteData;
}) {
  siteData.siteStyling.popup.typename = wBComponentTypeNames.popup;
  let node = siteData.siteStyling.popup;


  /*
      "popup-enabled",
      "pop-title",
      "pop-description",
      "pop-layout",
      "pop-image",
      "pop-goal",
      "pop-main-btn-link",
      "pop-main-btn-txt",
      "pop-sec-btn-link",
      "pop-sec-btn-txt",
      "pop-main-btn-link",

      "pop-title-text",
      "pop-text-color",
      "pop-desc-text",
      "pop-desc-color",
      "pop-main-btn",
      "pop-second-btn",
      "pop-bg-color",
      "pop-up-email-or-phone",
      "pop-up-gender"

    */
  const primaryList = [
    "popup-enabled",
    "pop-title",
    "pop-description",
    "pop-layout",
    "pop-image",
  ];

  const actionListGoalA = [
    "pop-goal",
    "pop-main-btn-link",
    "pop-main-btn-txt",
    "pop-sec-btn-link",
    "pop-sec-btn-txt",
  ];

  const actionListGoalB = [
    "pop-goal",
    "pop-up-email-or-phone",
    "pop-up-gender",
    "pop-disclaimer",
    "pop-completion-link"
  ];

  const displayList = [
    "show-popup",
    "pop-pages-to-show-on",
    "pop-timing",
    "pop-frequency",
    "pop-show-after-sub"];

  const styleList = [
  "pop-title-text",
  "pop-text-color",
  "pop-desc-text",
  "pop-desc-color",
  "pop-main-btn",
  "pop-second-btn",
  "pop-bg-color"];

  let goalList =
    getNodeComponentAttributeValue(node, "pop-goal", "") == ""
      ? actionListGoalA
      : actionListGoalB;

  siteData.siteStyling.cookieBanner.typename =
    wBComponentTypeNames.cookieBanner;

    const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const urlValidation = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;

    const validateLinks = ()=>{


      let keys = [];
      if(getNodeComponentAttributeValue(node,"pop-goal")==="subscribe"){
        keys = ["pop-completion-link"];
      }
      else{
        keys = ["pop-sec-btn-link","pop-main-btn-link"];
      }


      let linkResponse = "";
      for(let i = 0;i<keys.length;i++){
        let key = keys[i];
        let link = getNodeComponentAttributeValue(node,key,"");
        let lData = GetLinkAndType(link,LinkTypes.None);
        let keyName = "";
        switch(key){
          case "pop-main-btn-link":
            keyName = "Main Button";
            break;
          case "pop-sec-btn-link":
            keyName = "Secondary Button";
            break;
          case "pop-completion-link":
            keyName = "Completion Link";
            break;
        }



        if( link!="dismiss" )
        switch(lData.type){

          case LinkTypes.None:
            break;

          case "page":
            if(lData.link==="none"&&key !="pop-sec-btn-link"){//only secondary button can be none
              linkResponse=keyName;


            }
            break;
          case "url":
            if(link=="none")
              break;

            if( !urlValidation.test(lData.link)){
              linkResponse=keyName;

            }
            break;
          case "phone":

              let length = GetPhoneNumberLenthNoFormatting(siteData.userContext.countryCode??1);
              if(lData.link.length!==length){
                linkResponse=keyName;

              }
            break;
          case "email":
            if( !emailValidation.test(lData.link)){
              linkResponse=keyName;

            }
            break;
          case "none":
            break;
          default:
            break;

        }

      }



        setNodeComponentAttributeValue(node, "pop-up-valid", linkResponse);

    }

    validateLinks();

  return (
    <>
    <h2 className="panel-heading" style={{position:"sticky",top:"0",background:"#f8f8f8",zIndex:10,margin:"0 -10px",padding:"16px 10px"}}>Pop-Up</h2>
    {/* {getNodeComponentAttributeValue(node,"pop-up-valid","")=="invalid"&&<div className="font-small" style={{color:"darkred"}}>You have invalid links!</div>} */}
      {primaryList.map((att) => {
        return (
          <RenderAttributeInputFromDefinitionString
            definitionString={att}
            layoutObject={siteData.siteStyling.popup}
            siteData={siteData}
            saveFunc={saveFunc}
          />
        );
      })}

      <h2
        className="panel-heading"
        style={{ fontSize: "18px", textAlign: "center" }}
      >
        Advanced Settings
      </h2>
      <Accordian
        observerSizeChanges={true}
        label={
          <div className="att-category-label flex-row  align-center">
            Actions
          </div>
        }
        startExpanded={false}
        wrapperClass="category-acordian"
      >
        {goalList.map((att) => {
          if (
            (att == "pop-sec-btn-txt" &&
              getNodeComponentAttributeValue(node, "pop-sec-btn-link", "") ===
                "none") ||
            (att == "pop-main-btn-txt" &&
              getNodeComponentAttributeValue(node, "pop-main-btn-link", "") ===
                "none")
          ) {
            return null;
          }


          return (<>
            <RenderAttributeInputFromDefinitionString
              definitionString={att}
              layoutObject={siteData.siteStyling.popup}
              siteData={siteData}
              saveFunc={saveFunc}
            />
            {att=="pop-goal"&&  getNodeComponentAttributeValue(node,"pop-goal","")=="subscribe"&&  <div className="popup-input-desc input-description relative">Customers will have the <b>Subscribed</b> tag added to their profile</div>}
            </>
          );
        })}
        {goalList==actionListGoalB&&<>

        <div className="popup-input-desc input-description relative" style={{background:"#f2f2f2",marginTop:"8px"}}>Send customers to this link after they submit</div>
        <style>
          {`

            .close-margin{
            margin:auto;}

          .popup-input-desc{
            margin-top:-14px;
          }

          .invalid + .popup-input-desc{
            margin-top:-4px;
          }

          `
          }
        </style>
        </>

        }
        <br />
      </Accordian>

      <Accordian
        observerSizeChanges={true}
        label={
          <div className="att-category-label flex-row  align-center">
            Display
          </div>
        }
        startExpanded={false}
        wrapperClass="category-acordian"
      >
        {displayList.map((att) => {
          if (
            (att == "pop-pages-to-show-on" && getNodeComponentAttributeValue(node, "show-popup", "") === "")
          ) {
            return null;
          }

          return (
            <RenderAttributeInputFromDefinitionString
              definitionString={att}
              layoutObject={siteData.siteStyling.popup}
              siteData={siteData}
              saveFunc={saveFunc}
            />
          );
        })}
        <br />
      </Accordian>
      <Accordian
        observerSizeChanges={true}
        label={
          <div className="att-category-label flex-row  align-center">
            Style
          </div>
        }
        startExpanded={false}
        wrapperClass="category-acordian"
      >
        {styleList.map((att) => {
          return (
            <RenderAttributeInputFromDefinitionString
              definitionString={att}
              layoutObject={siteData.siteStyling.popup}
              siteData={siteData}
              saveFunc={saveFunc}
            />
          );
        })}
        <br />
      </Accordian>
      <br/>
      <br/>
    </>
  );
}

function RenderAttributeInputFromDefinitionString({
  definitionString,
  layoutObject,
  siteData,
  saveFunc,
}: {
  siteData: SiteData;
  layoutObject: AttributeCollection;
  saveFunc: Function;
  definitionString: string;
}) {
  const def = GetAttributeDefinition(definitionString);

  if (!def) {
    return null;
  }

  const updateAtt = (
    attribute: string,
    value: string,
    targetType: AttributeTargetType
  ) => {
    if (targetType == AttributeTargetType.Component)
      setNodeComponentAttributeValue(layoutObject, attribute, value);
    else
      setNodeStyleAttributeValue(
        layoutObject,
        ScreenSize.Desktop,
        attribute,
        value
      );

    siteData.onUpdateStyle();

    saveFunc();
  };

  return (
    <RenderAttributeInput
      label={def.label}
      definition={def}
      screenSize={ScreenSize.Desktop}
      layoutObject={layoutObject}
      updateFunc={updateAtt}
      saveFunc={saveFunc}
      siteData={siteData}
    />
  );
}
